import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqDashboardTaskSearchQuery, type ResDashboardTaskSearchQuery } from './types'

export const dashboardTaskSearchQuery = (payload: ReqDashboardTaskSearchQuery) =>
  queryOptions<ResDashboardTaskSearchQuery | null, unknown>({
    queryKey: [API_ENDPOINTS.business.v1.task.search.index, payload],
    queryFn: () => w.post(payload, API_ENDPOINTS.business.v1.task.search.index).json(),
  })
